import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Base from '../../utils/base'
import moment from "moment";

export default function ListRoom(props) {
  var base = new Base()
  const {t, i18n} = useTranslation()
  const momentNow = moment()

  const [numGuests, setNumGuests] = useState(1)
  const [checkInDate, setCheckInDate] = useState(null)
  const [checkOutDate, setCheckOutDate] = useState(null)

  const [infoData, setInfoData] = useState({})
  const [totalData, setTotalData] = useState(0)
  const [arr, setArr] = useState([
    // {
    //   id: '1',
    //   name: 'Deluxe Room',
    //   content: 'There are many variations of passages of Lorem Ipsum aagtilable',
    //   price: 120000,
    //   numPerson: 10,
    //   numStar: 3,
    //   image: 'assets/images/room/room-2-1.jpg?rnd=' + momentNow.format('HHmmss'),
    //   video: 'https://www.youtube.com/watch?v=4jnzf1yj48M',
    //   special: 'feature',
    // },
    // {
    //   id: '2',
    //   name: 'Superior Room',
    //   content: 'There are many variations of passages of Lorem Ipsum aagtilable',
    //   price: 100000,
    //   numPerson: 3,
    //   numStar: 5,
    //   image: 'assets/images/room/room-2-2.jpg?rnd=' + momentNow.format('HHmmss'),
    //   video: 'https://www.youtube.com/watch?v=4jnzf1yj48M',
    //   special: 'discount',
    //   specialText: '30% Off',
    // },
    // {
    //   id: '3',
    //   name: 'Standard Room',
    //   content: 'There are many variations of passages of Lorem Ipsum aagtilable',
    //   price: 200000,
    //   numPerson: 2,
    //   numStar: 5,
    //   image: 'assets/images/room/room-2-3.jpg?rnd=' + momentNow.format('HHmmss'),
    //   video: 'https://www.youtube.com/watch?v=4jnzf1yj48M',
    //   special: 'feature',
    // },
  ])

  useEffect(() => {
    var lang = window.localStorage.getItem('lang')
		i18n.changeLanguage(lang != null ? lang : 'en')

    get_data()

    setTimeout(() => {
      window.$('#checkin').datetimepicker({
        format: 'DD/MM/YYYY',
        allowInputToggle: true,
        minDate: moment(),
      })

      window.$('#checkout').datetimepicker({
        format: 'DD/MM/YYYY',
        allowInputToggle: true,
        minDate: moment(),
      })

      window.$('#checkin').on('change.datetimepicker', function(e) {
        setCheckInDate(moment(e.date))
      })
      window.$('#checkout').on('change.datetimepicker', function(e) {
        setCheckOutDate(moment(e.date))
      })

      
    }, 1000)
  }, [])

  useEffect(() => {
    if(checkInDate != null)
      reinit()
  }, [checkInDate])

  function reinit(){
    window.$('#checkout').datetimepicker('destroy')

    window.$('#checkout').datetimepicker({
      format: 'DD/MM/YYYY',
      allowInputToggle: true,
      minDate: checkInDate,
    })

    window.$('#checkout').on('change.datetimepicker', function(e) {
      setCheckOutDate(moment(e.date))
    })
  }

  function decreaseGuest(){
    if(numGuests > 1)
      setNumGuests(numGuests - 1)
  }

  function increaseGuest(){
    setNumGuests(numGuests + 1)
  }
  
  async function get_data() {
    var response = await base.request(base.url_api + "/room")

    if(response != null){
      if(response.status == "success"){
        for(let data of response.data){
          data.name = data.title
          data.content = data.description
          data.numStar = data.average_rating

          // for(let image of data.image)
          //   image.src = image.url_image

          // data.galleryOptions = {
          //   "items": data.image,
          //   "gallery": { "enabled": true },
          //   "type": "image"
          // }
          data.image = data.url_image
        }
        // console.log(response.data)
        setArr(response.data)
        setTotalData(response.recordsTotal)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  function onSearchClicked(){
    window.open(`https://www.e1-booking.com/widget?id=zoom-hotels-jemursari&room_id=&checkin=${checkInDate.format('DD-MM-YYYY')}&checkout=${checkOutDate.format('DD-MM-YYYY')}`, '_blank')
  }

  return (
    <section class="room-page">
      <div class="container">
        <div class="row gutter-y-30">
          <div class="col-lg-4">
            <div class="room-details__sidebar">
              <div class="room-details__sidebar__item room-details__sidebar__item--three wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
                <div class="sidebar__content">
                  <form class="sidebar__content__form__inner contact-form-validated" action="inc/sendemail.php" novalidate="novalidate">
                    <div class="sidebar__content__control">
                      <label for="checkin" style={{ fontSize: '.6rem', }}>{t('check_in')}</label>
                      <input className="datetimepicker-input" id="checkin" type="text" value={(checkInDate != null ? checkInDate : momentNow).format('DD/MM/YYYY')} data-toggle="datetimepicker" data-target="#checkin" style={{ fontSize: '1rem', }}/>
                      <i class="icon-calendar-5-1"></i>
                    </div>
                    <div class="sidebar__content__control">
                      <label for="checkout" style={{ fontSize: '.6rem', }}>{t('check_out')}</label>
                      <input className="datetimepicker-input" id="checkout" type="text" value={(checkOutDate != null ? checkOutDate : momentNow).format('DD/MM/YYYY')} data-toggle="datetimepicker" data-target="#checkout" style={{ fontSize: '1rem', }}/>
                      <i class="icon-calendar-5-1"></i>
                    </div>
                    {/* <div class="sidebar__content__control">
                      <label for="guests">{t('guest')}</label>
                      <div class="quantity-box">
                        <button type="button" class="sub" onClick={() => decreaseGuest()}><span class="fa fa-minus"></span></button>
                        <input id="guests" type="text" value={numGuests} onChange={(e) => setNumGuests(e.target.value)} />
                        <button type="button" class="add" onClick={() => increaseGuest()}><span class="fa fa-plus"></span></button>
                      </div>
                    </div> */}
                    {/* <div class="sidebar__content__control">
                      <label for="Location">Location</label>
                      <select name="location" className="form-control border-0 p-0" style={{ width: '93%', lineHeight: '100%', }} id="location">
                        <option value="select">Where to Next? </option>
                        <option value="spain">Spain</option>
                        <option value="spain">Canada</option>
                        <option value="africa">Africa</option>
                        <option value="europe">Europe</option>
                        <option value="thailand">Thailand</option>
                        <option value="dubai">Dubai</option>
                        <option value="australia">Australia</option>
                        <option value="swizerlan">Swizerlan</option>
                      </select>
                      <i class="icon-map-pin"></i>
                    </div> */}
                    <div class="sidebar__content__control">
                      <button type="button" onClick={() => onSearchClicked()} style={{ fontSize: '1rem', }} class="solinom-btn solinom-btn--base">{t('navbar.bookNow')}</button>
                    </div>
                  </form>
                </div>
              </div>
              {/* <div class="room-details__sidebar__item room-details__sidebar__item--two wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
                <h4 class="room-details__sidebar__title">Last Minute</h4>
                <ul class="room-details__sidebar__posts list-unstyled">
                  <li class="room-details__sidebar__posts__item">
                    <div class="room-details__sidebar__posts__image"> <img src="assets/images/room/room-s-1-1.jpg" alt="image" /> </div>
                    <div class="room-details__sidebar__posts__content">
                      <span class="room-details__sidebar__posts__price">$360</span>
                      <h4 class="room-details__sidebar__posts__title"><a href="blog-details-right.html">The Complete Web</a></h4>
                      <div class="room-details__sidebar__posts__star">
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                      </div>
                    </div>
                  </li>
                  <li class="room-details__sidebar__posts__item">
                    <div class="room-details__sidebar__posts__image"> <img src="assets/images/room/room-s-1-2.jpg" alt="image" /> </div>
                    <div class="room-details__sidebar__posts__content">
                      <span class="room-details__sidebar__posts__price">$340</span>
                      <h4 class="room-details__sidebar__posts__title"><a href="blog-details-right.html">The Complete Room</a></h4>
                      <div class="room-details__sidebar__posts__star">
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                      </div>
                    </div>
                  </li>
                  <li class="room-details__sidebar__posts__item">
                    <div class="room-details__sidebar__posts__image"> <img src="assets/images/room/room-s-1-3.jpg" alt="image" /> </div>
                    <div class="room-details__sidebar__posts__content">
                      <span class="room-details__sidebar__posts__price">$500</span>
                      <h4 class="room-details__sidebar__posts__title"><a href="blog-details-right.html">The Complete Hotel</a></h4>
                      <div class="room-details__sidebar__posts__star">
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                        <i class="icon-star1"></i>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="room-details__sidebar__item room-details__sidebar__item--three wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
                <a href="checkout.html" class="room-details__destination__item">
                  <img src="assets/images/room/room-s-3-1.jpg" alt="solinom image" />
                  <div class="room-details__destination__item__content">
                    <span class="room-details__destination__item__subtitle">Travel to </span>
                    <span class="room-details__destination__item__title">United Kingdom</span>
                  </div>
                </a>
              </div> */}
            </div>
          </div>
          <div class="col-lg-8">
            <div class="row gutter-y-30">
              <div class="room__info-top">
                <div class="room__showing-text-box">
                  <p class="room__showing-text" style={{ fontSize: '1rem', }}>{totalData.toLocaleString(base.locale_string)} {t('navbar.rooms')}</p>
                </div>
                <div class="room__showing-sort">
                  <select class="selectpicker" aria-label="Sort by popular">
                    <option selected>{t('sort_rating')}</option>
                    <option value="1">{t('sort_view')}</option>
                    <option value="2">{t('sort_price')}</option>
                  </select>
                </div>
              </div>

              {
                arr.map((data, index) => (
                  <div class="col-md-6" key={index}>
                    <div class="room-card-two wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='100ms'>
                      <div class="room-card-two__thumb" style={{ height: '30rem', }}>
                        <img src={data.image} alt="Deluxe Room" height="100%"/>
                        {
                          data.special == 'feature' ?
                          <p class="room-card-two__feature ">{t('feature')}</p>
                          : data.special == 'discount' &&
                          <p class="room-card-two__feature room-card-two__feature--two">{data.specialText}</p>
                        }
                        <div class="room-card-two__love">
                          <i class="icon-Heart"></i>
                        </div>
                      </div>
                      <div class="room-card-two__content">
                        <div class="room-card-two__content__top">
                          <div class="room-card-two__content__popup">
                            {/* <a href={data.video} class="room-card-two__content__popup__item video-popup">
                              <i class="icon-video-camera-1-1"></i>
                            </a> */}
                            <a href={data.image} class="room-card-two__content__popup__item img-popup">
                              <i class="icon-photo-camera-1"></i>
                            </a>
                          </div>
                        </div>
                        <div class="room-card-two__content__star">
                          { [...Array(data.numStar)].map((x, index1) => <i class="icon-star1" key={index1}></i>) }
                        </div>
                        <h4 class="room-card-two__content__title" style={{ fontSize: '1.5rem', }}><a href={"/rooms/detail?id=" + data.id}>{data.name}</a></h4>
                        <div class="room-card-two__content__text__box">
                          <p class="room-card-two__content__text" style={{ fontSize: '.8rem', }}>{data.content}</p>
                        </div>
                        <div class="room-card-two__content__number flex-column align-items-start" style={{ fontSize: '1rem', }}>
                          { data.before_price > 0 && <div class="" style={{ lineHeight: '1', }}><del>Rp. {data.before_price.toLocaleString(base.locale_string)}</del></div> }
                          
                          <div class="room-card-two__content__number__price">Rp. {data.price.toLocaleString(base.locale_string)}<span>/{t('night')}</span></div>
                          {/* <p class="room-card-two__content__number__parson">Person: <strong>{data.numPerson != null ? data.numPerson.toLocaleString(base.locale_string) : 0}</strong></p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              }

              {/* <div class="col-12">
                <ul class="post-pagination list-unstyled justify-content-start">
                  <li class="active"><a href="#">1</a></li>
                  <li><a href="#">2</a></li>
                  <li><a href="#"><i class="icon-right-arrow2"></i></a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
